import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogTitle, Paper, Popper, Fade } from '@material-ui/core/';
import { Send } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import DataTable from '../../../../components/DataTable/DataTable';
import CredentialService from '../../../../services/CredentialService/CredentialService';
import Close from "@material-ui/icons/Close";
import { useSetRecoilState, useRecoilValue } from 'recoil';
import { alertState, personalizationState } from '../../../../recoil-store/recoil-state';
import { convertToDateFormat } from '../../../../helpers/helper';

import './RequestDialog.css';

const useStyles = makeStyles((theme) => ({
    paper: { padding: theme.spacing(1) },
    button: {
        minWidth: 48,
        padding: 0,
        textTransform: 'none'
    }
}));

function RequestDialog(props) {
    const { t } = useTranslation();
    const personalization = useRecoilValue(personalizationState);

    const setAlert = useSetRecoilState(alertState)
    const handleClose = () => {
        props.setOpen(false);
    };
    const classes = useStyles();
    const [data, setData] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const [disable, setDisable] = useState(false);
    const [placement, setPlacement] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        const response = await CredentialService.getPublicCredentials();
        if (response) {
            if (response.status) { setData(response.data); }
            else {
                setAlert(alert => ({ ...alert, show: true, message: t(response.message), severity: 'error' }))
            }
        }
        else {
            setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }))
        }
        setLoading(false);
    };

    const handleSendClick = (newPlacement) => (event) => {
        setAnchorEl(event.currentTarget);
        setOpen((prev) => placement !== newPlacement || !prev);
        setPlacement(newPlacement);
    }

    const handleYesClick = async () => {
        setOpen(false);
        setDisable(true);
        const response = await CredentialService.postCredentialRequest({
            connection_id: data[placement].id,
            owner_id: data[placement].owner_id
        })
        if (response) {
            setAlert(alert => ({ ...alert, show: true, message: t(`CONTENT.REQUEST-TAB.${response.message}`), severity: response.status ? 'success' : 'error' }))
            fetchData();
            props.fetchData(props.tabIndex);
        }
        else {
            setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }))
        }
        setDisable(false);
    }

    const customColumn = [
        {
            id: 0,
            name: "id",
            label: " ",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    if (data && data[dataIndex]) {
                        return <span>{dataIndex + 1}.</span>;
                    }
                },
            },
        }, {
            name: 'name',
            label: t('CONTENT.DATATABLE.COLUMNS.CREDENTIAL_NAME'),
            options: { filter: true, sort: true }
        }, {
            name: 'created_at',
            label: t('CONTENT.CREDENTIAL-TAB.CREATION_DATE'),
            options: {
                filter: true, sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    if (data[dataIndex]) {
                        return convertToDateFormat(data[dataIndex].created_at, personalization.date_format);
                    }
                },
            }
        }, {
            name: 'actions',
            label: t('CONTENT.CREDENTIAL-TAB.ACTIONS'),
            options: {
                filter: false, sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    if (data[dataIndex]) {
                        return (
                            <Button disabled={disable} onClick={handleSendClick(dataIndex)}>
                                <Send />
                            </Button>
                        );
                    }
                },
            }
        }];

    return (
        <Dialog
            id="credential-request-modal"
            open={true}
            onClose={handleClose}
            data-test="about-dialog"
            fullWidth={true}
            maxWidth="md"
        >
            <Popper open={open} anchorEl={anchorEl} placement="right" transition style={{ zIndex: 1301 }}>
                {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={150}>
                        <Paper className={classes.paper}>
                            <div>{t('CONTENT.CREDENTIAL-TAB.SEND-REQUEST')}</div>
                            <Button className={classes.button} variant="outlined" color="secondary"
                                onClick={() => { setOpen(false) }}
                            >
                                {t('CONTENT.CREDENTIAL-TAB.NO')}
                            </Button>
                            <Button
                                className={classes.button} variant="outlined" color="primary"
                                onClick={handleYesClick} style={{ float: 'right' }}
                            >
                                {t('CONTENT.CREDENTIAL-TAB.YES')}
                            </Button>
                        </Paper>
                    </Fade>
                )}
            </Popper>
            <DialogTitle id="alert-dialog-title">
                <div id="about-title">
                    {t('CONTENT.CREDENTIAL-TAB.CREDENTIAL-REQUEST')}
                    <Button data-test="canceldialog-button" onClick={handleClose}>
                        <Close />
                    </Button>
                </div>
            </DialogTitle>
            <div style={{ margin: "-15px 15px 15px 15px" }}>
                <DataTable
                    className="request-table"
                    data-test="request-table"
                    customColumns={customColumn}
                    selectableRows="multiple"
                    data={data} title={''}
                    filter={false} download={false}
                    viewColumns={false} print={false}
                    loading={loading}
                />
            </div>
            <hr />
        </Dialog >
    );
}

export default RequestDialog;
